import styled from "styled-components";

export const BorderLeftESS = styled.div`
  border-left: 1px solid rgba(168, 214, 204, 0.31);
`;

export const UploadContainer = styled.div`
  @media (max-width: 992px) {
    background: linear-gradient(to right, #6C8CBF 40%, #fff 0%) top/10px 1px repeat-x,
    linear-gradient(#6C8CBF 40%, #fff 0%) right/1px 10px repeat-y,
    linear-gradient(to right, #6C8CBF 40%, #fff 0%) bottom/10px 1px repeat-x,
    linear-gradient(#6C8CBF 40%, #fff 0%) left/1px 10px repeat-y;
    padding: 3rem 2.5rem 2rem;
    border-radius: 5px;
    
    label {
      width: 100%;
      
      & > div {
        padding-top: .8rem;
        padding-bottom: .8rem;
      }
    }
  }

`;
